export default __webpack_public_path__ + "static/media/cuvette_rack_short.0b50222e.svg";